import React, { useCallback } from "react";
import { FiltersClearButton, FiltersContainer, FiltersLabel } from "@td/ui";
import { useProviderPanels } from "../contexts/provider-panels-context";
import { filtersMapper } from "../utils";
import { get } from "lodash";
import { translate } from "@td/shared_utils";
import { defaultFilters } from "../constants";

const Filters = React.memo(() => {
  const { filters, updateFilters, resetFilters, specialtyCode } = useProviderPanels();

  const handleChange = useCallback((name) => (value) => {
    updateFilters({ [name]: value });
  }, [updateFilters]);

  return (
    <FiltersContainer
      label={(
        <FiltersLabel>
          {translate(null, "provider_panel.filters", "label")}:
        </FiltersLabel>
      )}
      actions={(
        <FiltersClearButton
          onClick={resetFilters}
        >
          {translate(null, "provider_panel.filters", "clear_all")}
        </FiltersClearButton>
      )}
    >
      {filtersMapper.mapFiltersBySpecialty({ specialtyCode }).map(({ name, component: FilterComponent }) => (
        <FilterComponent
          key={name}
          value={get(filters, name, defaultFilters[name])}
          onChange={handleChange(name)}
          label={filtersMapper.getFilterLabel(name)}
          placeholder={filtersMapper.getFilterPlaceholder(name)}
        />
      ))}
    </FiltersContainer>
  );
});

Filters.displayName = "Filters";

export default Filters;
